import lang from 'dojo/_base/lang';
import on from 'dojo/on';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './WizardView.html?raw';
import "../GenericDialog/GenericDialog";
import _WidgetBaseSP from 'more/_WidgetBaseSP';
import WizardPage from '../Wizard/WizardPage';
import "../Wizard/WizardPage";


//import DataItems = require("DataItems");



const enum wizardNavigatorModes {
    "topNavigator"
}
class WizardView extends compose(_WidgetBaseSP) {
    templateString: any = template;

    private useHorizontalNavigatorBar: boolean = false;
    private showSummariesInNavigator: boolean = true;
    private useTopPreviousBtn: boolean = false;
    private useTopNextBtn: boolean = false;
    private useBottomNextBtn: boolean = false;
    private useBottomPreviousBtn: boolean = false;

    private pages: Array<Wizard.WizardPageEntry> = [];
    //private navigators: Array<Wizard.NavigatorEntry> = [];

    private currentDisplayedPage: number = -1;

    private _finishCallback: Function = null;

    _cyText: string = "";

    previousBtn: HTMLElement;
    nextBtn: HTMLElement;
    bottompreviousBtn: HTMLElement;
    bottomnextBtn: HTMLElement;
    bottomFinishBtn: HTMLElement;
    finishBtn: HTMLElement;
    cancelBtn: HTMLElement;
    pageContainer: HTMLElement;
    hiddenContainer: HTMLElement;
    chapterNavButton: HTMLElement;
    chapterNavButtonContainer: HTMLElement;
    topNavBar: HTMLElement;
    bottomNavBar: HTMLElement;

    setupNavigation(useTopnavigation: boolean,
        previousButton: boolean | "none" | "top" | "bottom" | HTMLElement,
        nextButton: boolean | "none" | "top" | "bottom" | HTMLElement) {

        this.useHorizontalNavigatorBar = useTopnavigation === true;

        this.UiModder.domClass.add(this.nextBtn, "w3-hide");
        this.UiModder.domClass.add(this.previousBtn, "w3-hide");
        this.UiModder.domClass.add(this.topNavBar, "w3-hide");
        this.UiModder.domClass.add(this.chapterNavButtonContainer, "w3-hide");
        this.UiModder.domClass.add(this.bottomNavBar, "w3-hide");
        this.UiModder.domClass.add(this.bottomnextBtn, "w3-hide");
        this.UiModder.domClass.add(this.bottompreviousBtn, "w3-hide");

        this.useBottomNextBtn = false;
        this.useBottomPreviousBtn = false;
        this.useTopNextBtn = false;
        this.useTopPreviousBtn = false;

        if (this.useHorizontalNavigatorBar) {
            this.UiModder.domClass.remove(this.topNavBar, "w3-hide");
            this.UiModder.domClass.remove(this.chapterNavButtonContainer, "w3-hide");
        }


        switch (previousButton) {
            case true:
                this.useTopPreviousBtn = true;
                this.useBottomPreviousBtn = true;
                this.UiModder.domClass.remove(this.topNavBar, "w3-hide");
                this.UiModder.domClass.remove(this.previousBtn, "w3-hide");
                this.UiModder.domClass.remove(this.bottomNavBar, "w3-hide");
                this.UiModder.domClass.remove(this.bottompreviousBtn, "w3-hide");
                break;
            case "top":
                this.useTopPreviousBtn = true;
               this.UiModder.domClass.remove(this.previousBtn, "w3-hide");
                this.UiModder.domClass.remove(this.topNavBar, "w3-hide");
                break;
            case "bottom":
                this.useBottomPreviousBtn = true;
                this.UiModder.domClass.remove(this.bottomNavBar, "w3-hide");
                this.UiModder.domClass.remove(this.bottompreviousBtn, "w3-hide");
                break;
        }

        if (typeof (previousButton) == "object" && previousButton.nodeName) {
            this.previousBtn = previousButton;
            on(this.previousBtn, "click", lang.hitch(this, this._onClick_Previous));
        }

        switch (nextButton) {
            case true:
                this.useTopNextBtn = true;
                this.useBottomNextBtn = true;
                this.UiModder.domClass.remove(this.topNavBar, "w3-hide");
                this.UiModder.domClass.remove(this.nextBtn, "w3-hide");
                this.UiModder.domClass.remove(this.bottomNavBar, "w3-hide");
                this.UiModder.domClass.remove(this.bottomnextBtn, "w3-hide");
                break;
            case "top":
                this.useTopNextBtn = true;
                this.UiModder.domClass.remove(this.topNavBar, "w3-hide");
                this.UiModder.domClass.remove(this.nextBtn, "w3-hide");
                break;
            case "bottom":
                this.useBottomNextBtn = true;
                this.UiModder.domClass.remove(this.bottomNavBar, "w3-hide");
                this.UiModder.domClass.remove(this.bottomnextBtn, "w3-hide");
                break;
        }

        if (typeof (nextButton) == "object" && nextButton.nodeName) {
            this.nextBtn = nextButton;
            on(this.nextBtn, "click", lang.hitch(this, this._onClick_Next));
        }
    }

    private setNavigationStyles(): void {

    }

    setupFinishEvent(callback: Function) {
        this._finishCallback = callback;
    }

    /**
* Nachricht (NICHT ID) zum Anzeigen hinterlegen.
* @param targetIndex Seite, für die die Regel gilt
 * @param rule Entweder: Objekt mit genauer Regeldefinition, oder vorgefertigte Variante als string
 * 'enableIfPreviousIsValid': vorherige Seite muss gültig sein, falls nicht ausgeblendet; aktuelle Seite wird sonst deaktiviert.
 * 'switchToIfPreviousIsValid': die Seite wird aktiviert und sofort angezeigt, sobald die vorherige gültig ist
 * @param delay Optionale Verzögerung, mit der die resultierenden Actions ausgeführt werden.

*/
    addPageRule(targetIndex: number, rule: Wizard.PageRule | "enableIfPreviousIsValid" | "enableIfPreviousAreValid" | "switchToIfPreviousIsValid" | "switchToIfPreviousAreValid", delay?: number) {
        let entry = this.getEntryByIndex(targetIndex);

        if (entry) {
            if (rule == "enableIfPreviousIsValid") {
                let newRule: Wizard.PageRule = {
                    neededValidPages: [{ pageIndex: targetIndex - 1, ignoreIfHidden: false }],
                    failureActions: ["disable"],
                    successActions: ["enable"],
                    customValidationFct: null
                };
                if (delay) {
                    newRule.delay = delay;
                }

                entry.rules.push(newRule);
                this.applyPageRules(targetIndex);
            } else if (rule == "enableIfPreviousAreValid") {
                let index = targetIndex;
                let neededPages = [];
                while (index - 1 >= 0) {
                    index--;
                    neededPages.push({ pageIndex: index, ignoreIfHidden: false });
                }
                let newRule: Wizard.PageRule = {
                    neededValidPages: neededPages,
                    failureActions: ["disable"],
                    successActions: ["enable"],
                    customValidationFct: null
                };
                if (delay) {
                    newRule.delay = delay;
                }

                entry.rules.push(newRule);
                this.applyPageRules(targetIndex);
            } else if (rule == "switchToIfPreviousIsValid") {
                let newRule: Wizard.PageRule = {
                    neededValidPages: [{ pageIndex: targetIndex - 1, ignoreIfHidden: false }],
                    failureActions: ["disable"],
                    successActions: ["enable", "switchTo"],
                    customValidationFct: null
                };
                if (delay) {
                    newRule.delay = delay;
                }
                entry.rules.push(newRule);
                this.applyPageRules(targetIndex);
            } else if (rule == "switchToIfPreviousAreValid") {
                let index = targetIndex;
                let neededPages = [];
                while (index - 1 >= 0) {
                    index--;
                    neededPages.push({ pageIndex: index, ignoreIfHidden: false });
                }
                let newRule: Wizard.PageRule = {
                    neededValidPages: neededPages,
                    failureActions: ["disable"],
                    successActions: ["enable", "switchTo"],
                    customValidationFct: null
                };
                if (delay) {
                    newRule.delay = delay;
                }

                entry.rules.push(newRule);
                this.applyPageRules(targetIndex);
            }
            else {

                if (delay) {
                    rule.delay = delay;
                }
                entry.rules.push(rule);
                this.applyPageRules(targetIndex);

            }
        }
        
    }

    resetPageRules(targetIndex: number) {
        let entry = this.getEntryByIndex(targetIndex);
        if (entry) {
            entry.rules = [];
        }
    }

    getValidPages(bIncludeHidden: boolean = false, bIncludeDisabled: boolean = true, bIncludeInvalid: boolean | "only" = false): Array<number> {
        let result = [];
        for (let entry of this.pages) {
            if ((entry.visible || bIncludeHidden === true) && (entry.selectable || bIncludeDisabled === true)) {

                let page: MdsLax<InstanceType<typeof WizardPage>> = entry.pageWidget;
                let isValid = page.isValid();

                if ((isValid && bIncludeInvalid != "only") || bIncludeInvalid === true || (!isValid && bIncludeInvalid == "only")) {

                    result.push(entry.index);
                }
            }
        }

        return result;
    }

    private _onGlobalClick(evt: MouseEvent): void {
        
    }
    /**
* Weitere Seite zum Wizard hinzufügen.
* @param targetScope Scope eines Widgets, auf den sich die Event- und Property-Parameter beziehen.
* @param visibleNode Ein HTML-Element, das in die Seite des Wizards eingebettet und angezeigt wird.
* @param changeEventName Name des Events, auf den der Wizard hört, um die Validierung der Seite zu starten.
* @param validationProperty Ein Property oder eine Funktion auf dem angegebenen Scope, an dem der Wizard ablesen kann ob die Seite 'gültig' ist.
* @param summaryProperty Property oder Funktion, die einen Zusammenfassungstext der Seite enthält.
* @param navigatorTitle Titel der Seite, der in der Navigation angezegit wird.
* @param collapsible Macht eine Seite ein- und ausklappbar (eingeklappt wird das Navigationselement mit Zusammenfassung angezeigt.)
* @param enabled Seite wählbar machen (Standard); wird danach von Pagerules dynamisch verwaltet.
* @param visible Seite sichtbar machen (Standard); wird danach von Pagerules dynamisch verwaltet.
*/
    addPage( targetScope: any,
        visibleNode: HTMLElement,
        changeEventName: string,
        validationProperty: string,
        summaryProperty: string,
        navigatorTitle: string,
        //collapsible: boolean = false,
        enabled?: boolean,
        visible: boolean = true ): number {
        let page = new WizardPage;

        page.setWidget(targetScope, visibleNode, changeEventName, validationProperty, summaryProperty);

        // falls nicht anders angegeben: die erste Page ist aktiv, danach wird deaktiviert
        if (enabled !== false && enabled !== true) {
            enabled = this.pages.length == 0;
        }


        let entry: Wizard.WizardPageEntry = {
            pageWidget: page,
            chapterNavButton: null,
            //name: internalName,
            title: navigatorTitle,
            index: this.pages.length,
            selectable: enabled,
            visible: visible,
            collapsed: false,
            valid: null,
            rules: []
        };

        this.pages.push(entry);
        this.UiModder.domClass.add(entry.pageWidget.domNode, "w3-hide");
        //page.placeAt(this.hiddenContainer);
        this.constructTopNavigator(entry);

        on(page, "requestSwitch", lang.hitch(this, this._onRequestSwitchPage, entry));
        on(page, "validation", lang.hitch(this, this._onPageValidation, entry));
        on(page, "newSummary", lang.hitch(this, this._onPageSummary, entry));


        if (this.currentDisplayedPage == -1) // initial
        {
            this.UiModder.domConstruct.empty(this.pageContainer);
            this.switchToPage(0);
        }

        page.placeAt(this.pageContainer);

        return entry.index;

    }

    private constructTopNavigator(entry: Wizard.WizardPageEntry) {
        if (entry.chapterNavButton) {
            this.UiModder.domConstruct.destroy(entry.chapterNavButton.node);
        }

        if (!this.useHorizontalNavigatorBar) return;

        let chapterNavButton = this.UiModder.domConstruct.create("button", {
            "className": "chapterNavButton mds-button-base",
            "innerHTML": "",
            "order": entry.index.toString()
        }, this.chapterNavButtonContainer);
        chapterNavButton.setAttribute("data-cy", ["wizard:chapterNav", this._cyText, entry.title || entry.index].filter(Boolean).join(":"));

        let buttonTitle = this.UiModder.domConstruct.create("div", {
            "className": "title",
            "innerHTML": entry.title
        }, chapterNavButton);

        let buttonSummary = this.UiModder.domConstruct.create("p", {
            "className": "summary w3-hide",
            "innerHTML": ""
        }, chapterNavButton);

        entry.chapterNavButton = {
            node: chapterNavButton,
            titleNode: buttonTitle,
            summaryNode: buttonSummary

        };

        this.setNavSelectable(entry, entry.selectable);

        this.setNavHidden(entry, !entry.visible);

        on(entry.chapterNavButton.node, "click", lang.hitch(this, this.switchToPage, entry));
    }

    private setNavSelectable(entry: Wizard.WizardPageEntry, bSelectable: boolean = true) {
        if (!entry) return;

        entry.selectable = bSelectable === true;

        if (entry.chapterNavButton) {
            this.UiModder.domClass.remove(entry.chapterNavButton.node, "inactive selectable");

            if (!entry.selectable) {
                this.UiModder.domClass.add(entry.chapterNavButton.node, "inactive");

            } else {
                this.UiModder.domClass.add(entry.chapterNavButton.node, "selectable");
            }
        }
    }

    

    private _onRequestSwitchPage(entry: Wizard.WizardPageEntry) {
        if (entry.selectable == true && entry.visible == true) {
            this.switchToPage(entry);
        }
    }

    private getNextVisiblePageIndex(index: number, bMustBeSelecatble: boolean = true) {
        for (let entry of this.pages) {
            if (entry.index > index && entry.visible === true &&
                (entry.selectable === true || bMustBeSelecatble === false)) {
                return entry.index;
            }
        }

        return -1;
    }

    private getPreviousVisiblePageIndex(index: number, bMustBeSelecatble: boolean = true) {
        let highestIndex: number = -1;
        for (let entry of this.pages) {
            if (entry.index < index && entry.visible === true &&
                (entry.selectable === true || bMustBeSelecatble === false)) {
                highestIndex = entry.index;
            } else if (entry.index >= index) {
                break;
            }
        }

        return highestIndex;
    }

    private applyPageRules(targetIndex?: number): void {
        let pages = this.pages;
        if (targetIndex >= 0) {
            pages = [];
            pages.push(this.getEntryByIndex(targetIndex));
        }
        //debugger;
        // prüfen welche Pages Regeln hinterlegt haben und die jetzt valid sind:
        let switchToTargets = [];
        let switchToTarget = { index: -1, delay: 0 };
        for (let page of pages) {
            let result: boolean = null;
            let pagewidget: MdsLax<InstanceType<typeof WizardPage>> = page.pageWidget;
            if (page.rules) {
                for (let rule of page.rules) {
                    let ruleValid: boolean = null;
                    let timeout = rule.delay;
                    if (!timeout) {
                        rule.delay = 0;
                    }

                    if (typeof (rule.customValidationFct) == "function") {
                        ruleValid = rule.customValidationFct();
                        //debugger;
                    }
                    if (rule.neededValidPages && ruleValid !== false) {
                        let pagesValid: boolean = null;

                        for (let pageToCheck of rule.neededValidPages) {
                            let entryToCheck = this.getEntryByIndex(pageToCheck.pageIndex);
                            if (entryToCheck) {
                                let widgetToCheck: MdsLax<InstanceType<typeof WizardPage>> = entryToCheck.pageWidget;

                                // wenns versteckt ist: als gültig ansehen, wenn das Ignore-Flag auch gesetzt ist
                                let valid = pageToCheck.ignoreIfHidden === true && entryToCheck.visible === false;

                                if (!valid) {
                                    valid = entryToCheck.valid === true;// widgetToCheck.isValid();
                                }
                                if (!valid) {
                                    pagesValid = false;
                                    break;
                                } else {
                                    pagesValid = true;
                                }
                            }
                        }

                        if (pagesValid === false) {
                            ruleValid = false;
                        } else if (pagesValid === true) {
                            ruleValid = true;
                        }
                    }  

                    if (ruleValid !== false) {
                        for (let action of rule.successActions) {
                            switch (action) {
                                case "disable":
                                    //setTimeout(lang.hitch(this, this.enablePage, page.index, false), timeout);
                                    this.enablePage(page.index, false);
                                    break;

                                case "enable":
                                    //setTimeout(lang.hitch(this, this.enablePage, page.index, true), timeout);
                                    this.enablePage(page.index, true);
                                    break;

                                case "hide":
                                    //setTimeout(lang.hitch(this, this.hidePage, page.index, true), timeout);
                                    this.hidePage(page.index, true);
                                    break;

                                case "show":
                                    //setTimeout(lang.hitch(this, this.hidePage, page.index, false), timeout);
                                    this.hidePage(page.index, false);
                                    break;

                                case "switchTo":
                                    switchToTargets.push(page.index);
                                    switchToTarget = {
                                        index: page.index, delay: timeout
                                    };
                                    break;
                            }
                        }
                    }

                    else {
                        for (let action of rule.failureActions) {
                            switch (action) {
                                case "disable":
                                    //setTimeout(lang.hitch(this, this.enablePage, page.index, false), timeout);
                                    this.enablePage(page.index, false);
                                    break;

                                case "enable":
                                    //setTimeout(lang.hitch(this, this.enablePage, page.index, true), timeout);
                                    this.enablePage(page.index, true);
                                    break;

                                case "hide":
                                    //setTimeout(lang.hitch(this, this.hidePage, page.index, true), timeout);
                                    this.hidePage(page.index, true);
                                    break;

                                case "show":
                                    //setTimeout(lang.hitch(this, this.hidePage, page.index, false), timeout);
                                    this.hidePage(page.index, false);
                                    break;
                            }
                        }
                    }

                    if (ruleValid === false) {
                        result = false;
                        break;
                    }
                    else if( result == null) {
                        result = true;
                    }
                }
            }
        }

        if (switchToTarget.index != -1) {
            setTimeout(lang.hitch(this, this.switchToPage, switchToTarget.index), switchToTarget.delay);
        }

    //    switchToTargets.sort(function (a, b) { return b.page.index - a.page.index });
    //    for (let entry of switchToTargets) {
    //        console.debug("checking if switch to page " + entry.page.index, entry.page.selectable);
    //        if (entry.page.selectable) {
    //            console.debug("gonna switch to page " + entry.page.index, entry.page, switchToTargets);
    //            setTimeout(lang.hitch(this, this.switchToPage, entry.page), entry.delay);
    //            break;
    //        }
    //    }
    }

    //private _resultEmitHandle: number = null;
    //private _delayedResultEmit(delay: number = 100) {
    //    if (this._resultEmitHandle != null) {
    //        clearTimeout(this._resultEmitHandle);
    //        this._resultEmitHandle = null;
    //    }

    //    setTimeout(lang.hitch(this, this.emit, "change"))
    //}

    private _onPageValidation(entry: Wizard.WizardPageEntry, valid: boolean) {
        //console.debug("_onPageValidation", entry, valid);
        if (!entry) return;
        //debugger;
        this.validatePage(entry.index, valid);

        
    }
    private _onPageSummary(entry: Wizard.WizardPageEntry, summary: string) {
        if (this.showSummariesInNavigator) {
            this.setNavSummary(entry, summary);
        }

        //this.emit("change", entry);
        this.emit("pageSummary", entry);
    }
    private setNavSummary(entry: Wizard.WizardPageEntry, value: string) {
        if (!entry) return;
        if (!entry.chapterNavButton || !entry.chapterNavButton.summaryNode) return;

        this.UiModder.domAttr.set(entry.chapterNavButton.summaryNode, "innerHTML", value);

        if (value) {
            this.UiModder.domClass.remove(entry.chapterNavButton.summaryNode, "w3-hide");
        } else {
            this.UiModder.domClass.add(entry.chapterNavButton.summaryNode, "w3-hide");
        }
    }

    private setNavSelected(pageIndex?: number, bSelected: boolean = true) {
        let entry: Wizard.WizardPageEntry = this.getEntryByIndex(pageIndex);

        //console.debug("setNavSelected", pageIndex, bSelected, entry);

        if (!entry || !entry.chapterNavButton) return;

        if (!pageIndex) pageIndex = this.currentDisplayedPage;

        this.UiModder.domClass.remove(entry.chapterNavButton.node, "selected");

        if (bSelected === true) {
            this.UiModder.domClass.add(entry.chapterNavButton.node, "selected");

        }
    }

    private setNavValid(entry: Wizard.WizardPageEntry, bValid: boolean = true) {
        if (!entry) return;
        if (!entry.chapterNavButton || !entry.chapterNavButton.node) return;

        this.UiModder.domClass.remove(entry.chapterNavButton.node, "valid");

        if (bValid === true) {
            this.UiModder.domClass.add(entry.chapterNavButton.node, "valid");

        }

    }

    hidePage(pageIndex: number, bHide: boolean = true) {
        let entry = this.getEntryByIndex(pageIndex);
        if (entry) {
            if (entry.visible != bHide === false) {
                entry.visible = !bHide;
                // der Wert ist geändert. dann müssen ggf. andere Seiten reagieren, die Regeln hinterlegt haben
                this.applyPageRules();
            }

            this.setNavHidden(entry, bHide);
            if (entry) {
                if (this.currentDisplayedPage == pageIndex) {
                    pageIndex--;
                    pageIndex--;
                    this.getNextVisiblePageIndex(pageIndex);
                }
            }
        }
    }

    private validatePage(pageIndex: number, bValid: boolean = true) {
        let entry = this.getEntryByIndex(pageIndex);
        if (entry) {

            if (entry.valid != bValid === true) {
                entry.valid = bValid;

            }
            //debugger;
            // der Wert ist geändert. dann müssen ggf. andere Seiten reagieren, die Regeln hinterlegt haben
            this.applyPageRules();

            this.setNavValid(entry, bValid);

            this.emit("change", entry);
            this.emit("pageValidation", entry);
        }
    }

    checkPageValid(pageIndex: number): boolean {
        let entry = this.getEntryByIndex(pageIndex);

        if (entry) {
            return entry.valid;
        }
        return null;
    }


    getPageSummary(pageIndex: number): string {
    let entry = this.getEntryByIndex(pageIndex);

        if (entry) {
            let widget: MdsLax<InstanceType<typeof WizardPage>> = entry.pageWidget;

            return widget.getSummary();
        }

    return null;
}

    enablePage(pageIndex: number, bEnable: boolean = true) {
        let entry = this.getEntryByIndex(pageIndex);
        this.setNavSelectable(entry, bEnable);
    }


    private setNavHidden(entry: Wizard.WizardPageEntry, bHidden: boolean = false) {

        if (!entry || !entry.chapterNavButton) return;

        entry.visible = bHidden === false;

        this.UiModder.domClass.add(entry.chapterNavButton.node, "w3-hide");

        if (entry.visible) {
            this.UiModder.domClass.remove(entry.chapterNavButton.node, "w3-hide");

        } 
    }

    private getEntryByIndex(pageIndex: number): Wizard.WizardPageEntry {
        if (pageIndex == null) return null;

        for (let entry of this.pages) {
            if (entry.index == pageIndex) {
                return entry;
            }
        }

        return null;
    }

    //private getEntryByName(name: string): Wizard.WizardPageEntry {
    //    if (!name) return null;

    //    for (let entry of this.pages) {
    //        if (entry.name == name) {
    //            return entry;
    //        }
    //    }

    //    return null;
    //}

    nextPage(steps: number = 1) {
        let targetIndex = this.getNextVisiblePageIndex(this.currentDisplayedPage);
        this.switchToPage(targetIndex);
    }

    previousPage(steps: number = 1) {
        let targetIndex = this.getPreviousVisiblePageIndex(this.currentDisplayedPage);
        
        this.switchToPage(targetIndex);
    }

    private _onClick_Previous(evt: MouseEvent) {
        this.previousPage();
    }
    private _onClick_Next(evt: MouseEvent) {
        this.nextPage();
    }

    private _onClick_Finish(evt: MouseEvent) {
        this._onWizardFinished();
    }



    switchToPage(target: number | Wizard.WizardPageEntry) {
        let newEntry: Wizard.WizardPageEntry = null; 
        let targetIndex = -1;
        if (target == null) return;
        if (typeof (target) == "number") {
            if (target < 0 ) {
                return;
            }
            newEntry = this.getEntryByIndex(target);
            targetIndex = newEntry.index;
            
        } else if (typeof (target) == "object") {
            newEntry = target;
            targetIndex = newEntry.index;
        }
        //debugger;
        if (targetIndex != this.currentDisplayedPage) {
            
            //console.debug("switchToPage - target - current", targetIndex, this.currentDisplayedPage, newEntry);
            if (newEntry && newEntry.selectable) {

                let currentEntry = this.getEntryByIndex(this.currentDisplayedPage);
                if (currentEntry) {
                    //currentEntry.pageWidget.placeAt(this.hiddenContainer);
                    this.UiModder.domClass.add(currentEntry.pageWidget.domNode, "w3-hide");
                    this.setNavSelected(this.currentDisplayedPage, false);
                }


                if (newEntry) {
                    //newEntry.pageWidget.placeAt(this.pageContainer);
                    this.UiModder.domClass.remove(newEntry.pageWidget.domNode, "w3-hide");
                    this.setNavSelected(newEntry.index);
                }

                this.currentDisplayedPage = targetIndex;
                this.emit("pageswitch", newEntry);
                //debugger;
                let previousAvailable = this.getPreviousVisiblePageIndex(this.currentDisplayedPage) > -1;
                let nextAvailable = this.getNextVisiblePageIndex(this.currentDisplayedPage) > -1;
                if (this.useBottomNextBtn) {
                    this.UiModder.domClass.toggle(this.bottomnextBtn, "selectable", nextAvailable);
                    this.UiModder.domClass.toggle(this.bottomnextBtn, "inactive", !nextAvailable);                    
                }

                if (this.useTopNextBtn) {
                    this.UiModder.domClass.toggle(this.nextBtn, "selectable", nextAvailable);
                    this.UiModder.domClass.toggle(this.nextBtn, "inactive", !nextAvailable);    
                }

                if (this.useTopPreviousBtn) {
                    //debugger;
                    this.UiModder.domClass.toggle(this.previousBtn, "selectable", previousAvailable);
                    this.UiModder.domClass.toggle(this.previousBtn, "inactive", !previousAvailable);
                }

                if (this.useBottomPreviousBtn) {
                    this.UiModder.domClass.toggle(this.bottompreviousBtn, "selectable", previousAvailable);
                    this.UiModder.domClass.toggle(this.bottompreviousBtn, "inactive", !previousAvailable);
                }
            }
        }
    }

    private _onWizardFinished(): void {
        if (typeof (this._finishCallback) == "function") {
            this._finishCallback();
        }
    }

    getPageSelectable(index: number): boolean {
        let entry = this.getEntryByIndex(index);
        if (entry) {
            return entry.selectable;
        }

        return false;
    }

    getCurrentSelectedPageIndex(): number {
        return this.currentDisplayedPage;
    }


    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
        this.addSubscription("/Global/Click", lang.hitch(this, this._onGlobalClick));

        this.pages = [];

    }

    startup(): void {
        super.startup.apply(this, arguments as any);

        this.PitHelper._structureFormat = "json";

    }
}

export default mdsWidget(WizardView);
